import { NavLink, useLocation } from 'react-router-dom';
import {
    LayoutDashboard,
    Users,
    Calendar,
    FileText,
    Video,
    MessageSquare,
    Settings,
    Activity,
    LogOut,
} from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { useI18n, LanguageToggle } from '../i18n';

export function Sidebar() {
    const location = useLocation();
    const { user, logout } = useAuth();
    const { t } = useI18n();

    const navItems = [
        { to: '/', icon: LayoutDashboard, label: t('nav.dashboard') },
        { to: '/patients', icon: Users, label: t('nav.patients') },
        { to: '/appointments', icon: Calendar, label: t('nav.appointments') },
        { to: '/encounters', icon: FileText, label: t('nav.encounters') },
        { to: '/telehealth', icon: Video, label: t('nav.telehealth') },
        { to: '/messages', icon: MessageSquare, label: t('nav.messages') },
    ];

    const bottomItems = [
        { to: '/settings', icon: Settings, label: t('nav.settings') },
    ];

    return (
        <aside className="sidebar" id="sidebar-nav">
            <div className="sidebar-logo" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div className="sidebar-logo-icon">
                        <Activity size={20} />
                    </div>
                    ClinicOS
                </div>
                <LanguageToggle />
            </div>

            <nav className="sidebar-nav">
                <div className="sidebar-section-title">{t('nav.section.main')}</div>
                {navItems.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={({ isActive }) =>
                            `sidebar-link${isActive && (item.to === '/' ? location.pathname === '/' : true) ? ' active' : ''}`
                        }
                        end={item.to === '/'}
                    >
                        <item.icon size={18} />
                        {item.label}
                    </NavLink>
                ))}

                <div className="sidebar-section-title">{t('nav.section.system')}</div>
                {bottomItems.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
                    >
                        <item.icon size={18} />
                        {item.label}
                    </NavLink>
                ))}

                <button className="sidebar-link" onClick={logout}>
                    <LogOut size={18} />
                    {t('auth.logout')}
                </button>
            </nav>

            {user && (
                <div style={{ padding: '0 16px 16px', fontSize: 11, color: 'rgba(255,255,255,0.5)', textAlign: 'center' }}>
                    {user.name}
                </div>
            )}
        </aside>
    );
}
